<template>
  <div class="article-view">
    <router-link
      :to="getJumpWikiDetailUrl(item.game_alias || item.game.alias, item.game_id || item.game.id, item.id, true)"
    >
      <div class="title">
        {{ item.title }}
      </div>
      <!-- 4 帖子，17 提问不显示内容 -->
      <div v-if="item.type === 4" class="desc">
        {{ item.summary }}
      </div>

      <!-- 优先显示视频，其次显示图片3张，多余的使用数字标记 -->
      <template v-if="item.video_list_format && item.video_list_format.length">
        <ArticleVideo :videoList="item.video_list_format" />
      </template>
      <template v-else-if="item.thumb.length">
        <div class="media-box">
          <ArticleImage :imageList="imageList" :count="item.image_num" />
        </div>
      </template>

      <div class="footer">
        <div class="left" @click="handleUserProfile">
          <img class="icon" v-lazy="handleImgSize(item.user.avatar, 'mini')" />
          <span class="nick">{{ item.user.username }}</span>
          <span class="time">{{ formatDuration(item.updated_at) }}</span>
        </div>
        <div class="right">
          <div class="item">
            <!-- <img class="icon" :src="require('@/assets/zs_imgs/article-dianzan.png')" /> -->
            <i class="icon zsicon icon-dianzan3"></i>
            <span class="count">{{ formatCount(item.like_count) }}</span>
          </div>
          <div class="item">
            <!-- <img class="icon" :src="require('@/assets/zs_imgs/article-look.png')" /> -->
            <i class="icon zsicon icon-liulan"></i>
            <span class="count">{{ formatCount(item.view_count) }}</span>
          </div>
          <div class="item">
            <!-- <img class="icon" :src="require('@/assets/zs_imgs/article-pinglun.png')" /> -->
            <i class="icon zsicon icon-pinglun2"></i>
            <span class="count">{{ formatCount(item.comment_count) }}</span>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>
<script>
import dayjs from "@/plugins/dayjs";
import { getJumpWikiDetailUrl } from "@/plugins/util";

import ArticleImage from "./ArticleImage.vue";
import ArticleVideo from "./ArticleVideo.vue";

export default {
  name: "ArticleView",
  components: { ArticleImage, ArticleVideo },
  props: ["item"],
  data() {
    return {
      imageList: []
    };
  },
  watch: {
    "item.thumb": {
      immediate: true,
      handler(value) {
        if (!value) {
          this.imageList = [];
        } else {
          this.imageList = value.split(",");
        }
      }
    }
  },
  methods: {
    getJumpWikiDetailUrl,
    handleUserProfile() {
      window.open(`/user/index/${this.item.user.uid}.html`);
    },
    formatDuration(time) {
      time = Date.now() / 1000 - time;
      if (time < 60) return "刚刚";
      const duration = dayjs.duration(time, "seconds");
      if (time < 60 * 60) return `${duration.format("m分钟前")}`;
      if (time < 60 * 60 * 24) return `${duration.format("H小时前")}`;
      if (time < 60 * 60 * 24 * 7) return `${duration.format("D天前")}`;
      return `${dayjs(Date.now() - time * 1000).format("YYYY年M月D日")}`;
    },
    formatCount(count) {
      if (count > 100000000) {
        const num = count / 100000000;
        if (num == (count / 100000000).toFixed(1)) {
          return num + "亿";
        } else {
          return (count / 100000000).toFixed(1) + "亿+";
        }
      } else if (count >= 10000) {
        const num = count / 10000;
        if (num == (count / 10000).toFixed(1)) {
          return num + "W";
        } else {
          return (count / 10000).toFixed(1) + "W+";
        }
      } else if (count >= 1000) {
        const num = count / 1000;
        if (num == (count / 1000).toFixed(1)) {
          return num + "K";
        } else {
          return (count / 1000).toFixed(1) + "K+";
        }
      } else {
        return count;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.article-view {
  position: relative;
  margin: 0 20px;
  border-bottom: 1px solid var(--zs-qz-tabs-border-color);
  &:last-child {
    border-bottom-width: 0;
  }
  .title {
    color: var(--zs-qz-entry-text-color);
    font-size: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 48px;
  }
  .desc {
    color: var(--zs-qz-article-des-color);
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .media-box {
    padding: 14px 0;
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 17px 0;
    .left,
    .right {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .left {
      gap: 5px;
      color: var(--zs-qz-article-option-text-color);
      font-size: 12px;
      .icon {
        width: 18px;
        height: 18px;
        display: block;
        border-radius: 20px;
      }
      .nick {
        margin-right: 20px;
      }
    }
    .right {
      display: flex;
      align-items: center;
      gap: 40px;
      .item {
        display: flex;
        align-items: center;
        gap: 5px;
        color: var(--zs-qz-article-option-text-color);
        .icon {
          display: block;
          font-size: 16px;
        }
        .count {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
